import { createContext, useState, useContext, ReactNode } from "react";

interface Props {
    children?: ReactNode;
}

interface layoutData {
    menuOpen?: boolean;
    toogleMenuOpen?: Function;
}

const LayoutContext = createContext<layoutData>({});

export const useLayout = () => {
    const layoutData = useContext(LayoutContext);
    return layoutData;
};

export const LayoutProvider = ({ children }: Props) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const toogleMenuOpen = () => {
        setMenuOpen(!menuOpen);
    };

    const values = {
        menuOpen: menuOpen,
        toogleMenuOpen: toogleMenuOpen
    };
    return <LayoutContext.Provider value={values}>{children}</LayoutContext.Provider>;
};
